import React from 'react';
import Markdown from 'react-markdown';
import { useDispatch } from 'react-redux';
import { inMiniProgram } from 'utils/WeChatUtil';
import { getOSType } from 'utils';
import i18n from 'utils/I18n';
import './CustomMarkdown.scss';

function LinkRenderer(props) {
    const isInMiniProgram = inMiniProgram();
    const dispatch = useDispatch();
    const showToast = () => {
        dispatch({
            type: 'navBars/updateState',
            payload: {
                toastShowing: {
                    value: true,
                    showTickIcon: true,
                    content: i18n.t("weChatUrlCopied"),
                },
            }
        })
    }

    return (
        <a href={"#"} onClick={(e) => {
            e.preventDefault();
            if (!isInMiniProgram) {
                window.open(props.href, "_blank", "noopener,noreferrer")
                return
            }
            const osType = getOSType();
            if (osType === "Android") {
                import('copy-to-clipboard').then(({ default: copy }) => {
                    copy(props.href, {
                        format: 'text/plain',
                    })
                    showToast()
                })
            } else {
                navigator.clipboard && navigator.clipboard.writeText(props.href).then(() => {
                    showToast()
                }).catch(e => {
                    console.log("navigator.clipboard error:", e)
                })
            }
        }}>
            {props.children}
        </a>
    );
}


function CustomMarkdown(props) {
    return <div className='custom-markdown-container'>
        <Markdown {...props} components={{ a: LinkRenderer }}>{props.children}</Markdown>
    </div>
}

export default CustomMarkdown;